import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import counterReducer from '../features/counter/counterSlice';
import userReducer from './slices/user/userSlice'
import contentReducer from './slices/content/contentSlice'
import adventureReducer from './slices/adventure/adventureSlice'
import characterReducer from './slices/character/characterSlice'
import npcReducer from './slices/npc/npcSlice'

export const store = configureStore({
  reducer: {
    counter: counterReducer,
    user: userReducer,
    content: contentReducer,
    adventure: adventureReducer,
    character: characterReducer,
    npc: npcReducer
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
